/**
 * Constants for the slots scheduler feature
 */

// Number of slots to fetch from the API to ensure coverage
// Note: In SlotsStep, this is multiplied by 2 for better 2-week coverage
export const SLOTS_TO_FETCH = 100;

// Maximum number of visible time slots per day in the calendar grid
export const MAX_VISIBLE_SLOTS_PER_DAY = 5;

// Number of days to display in the calendar view (1 week)
export const CALENDAR_DAYS = 7;

/**
 * Main steps of the online scheduler funnel.
 *
 * Kept here rather than in `StepNavigationContext` so the validation/access
 * helpers can read them without importing that module — it is mocked wholesale in
 * several test suites, and a constant hidden behind a mock is a constant waiting
 * to be undefined.
 */
export const FIRST_STEP = 1;
export const TOTAL_STEPS = 5;

/** Step name (as accepted in the `?step=` query param) → step number. */
export const STEP_MAP: Record<string, number> = {
  services: 1,
  property: 2,
  schedule: 3,
  contact: 4,
  summary: 5,
};

/** Step number → step name. */
export const STEP_NAMES: Record<number, string> = {
  1: 'services',
  2: 'property',
  3: 'schedule',
  4: 'contact',
  5: 'summary',
};
